import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'

import reportReducer from 'store/reducers/reportReducer'
import preferenceReducer from 'store/reducers/preferenceReducer'
import uiReducer from 'store/reducers/uiReducer'
import configurationReducer from 'store/reducers/configurationReducer'
import clapiReducer from 'store/reducers/clapiReducer'
import searchReducer from 'store/reducers/searchReducer'
import leadgenReducer from 'store/reducers/leadgenReducer'

const searchPersistConfig = {
  key: 'search',
  storage: storageSession,
  whitelist: ['config', 'property', 'integratorShortName']
}

const createRootReducer = () => combineReducers({
  preference: preferenceReducer,
  report: reportReducer,
  ui: uiReducer,
  configuration: configurationReducer,
  clapi: clapiReducer,
  search: persistReducer(searchPersistConfig, searchReducer),
  leadgen: leadgenReducer
})

export default createRootReducer
